<template lang="pug">
    div
        Card(v-for="(origin, index) in value" :key="index" dis-hover)
            Row
                h4 {{ origin.host }}
            Row
                p {{ getBaseFieldsDescription(origin) }}
            template(v-if="getCustomSettingFieldsDescription(origin) !== '' && origin.isCustomSettingEnabled")
                h4(orientation="left" size="small") Custom Setting
                p {{ getCustomSettingFieldsDescription(origin) }}
            template(slot="extra")
                Button(@click="editOrigin(origin)") {{ $t("rcmtable.editText")}}
                Button(@click="removeOrigin(index)") {{ $t("rcmtable.deleteText")}}
        Button(@click="isOriginModalShow = true") {{ $t("rcmtable.addTagText")}}
        Modal(v-model="isOriginModalShow" :title="originModalTitle" :closable="false" :mask-closable="false")
            Form(:ref="isEditMode? 'editForm' : 'addForm'" :model="currentOriginFormData" v-if="isOriginModalShow" label-position="left" :label-width="120")
                //- 一般欄位
                FormItem(
                    v-for="field in baseFields"
                    :key="field.prop"
                    :prop="field.prop"
                    :label="field.label"
                    v-show="field.formItem.vShowFieldVal()"
                    )
                    component(
                        :is="field.component"
                        v-model="currentOriginFormData[field.prop]"
                        :formData="currentOriginFormData"
                        :formItem="field.formItem"
                        :style="field.style"
                    )
                //- customSetting 欄位
                Card(v-if="isCustomSettingCardVisible" dis-hover)
                    FormItem(
                        v-for="field in customSettingFields"
                        :key="field.prop"
                        :prop="`customSetting.${field.prop}`"
                        :label="field.label"
                        v-show="field.formItem.vShowFieldVal()"
                        )
                        component(
                            :is="field.component"
                            v-model="currentOriginFormData.customSetting[field.prop]"
                            :formData="currentOriginFormData"
                            :formItem="field.formItem"
                            :style="field.style"
                        )
            div(slot="footer")
                Button(@click="isEditMode? cancelEditOrigin() : cancelAddOrigin()") {{$t('rcmtable.cancelText')}}
                Button(@click="isEditMode? confirmEditOrigin() : confirmAddOrigin()") {{$t('rcmtable.confirmText')}}

</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import FormInput from "@/components/rcmTableFormItems/Input";
import FormSelect from "@/components/rcmTableFormItems/Select/index.js";
import FormInputNumber from "@/components/rcmTableFormItems/InputNumber";
import FormCheckbox from "@/components/rcmTableFormItems/Checkbox";
import { ipValidate } from "@/api/formValidate";
import enumList from "@/libs/enumList";

export default {
    name: "AdvanceOriginsForm",
    components: { FormSelect, FormInputNumber, FormCheckbox, FormInput },
    props: {
        value: {
            default: () => []
        },
        formData: {}
    },
    watch: {
        value: function(newVal, oldVal) {
            this.$emit("input", newVal);
        },
        "currentOriginFormData.customSetting.scheme"(val) {
            if (val === "https" || val === "static") {
                this.currentOriginFormData.customSetting.port = 443;
            }

            if (val === "http") {
                this.currentOriginFormData.customSetting.port = 80;
            }
        },
    },
    data() {
        return {
            // ====== Modal 相關 ======
            isEditMode: false,
            isOriginModalShow: false,
            // ====== 新增、編輯的資料 ======
            addOriginFormData: this.getEmptyFormData(),
            editOriginFormData: this.getEmptyFormData(),
            // ====== 表單各項欄位 ======
            baseFields: [
                {
                    prop: "host",
                    label: this.$i18n.t("originPolicy.host"),
                    component: "FormSelect",
                    formItem: {
                        placeholder: "a.b.c.d",
                        options: [],
                        remoteOptions: async (queryValue, queryParams) => {
                            queryValue = queryValue || "*";
                            queryParams.groupName = this.formData.groupName;
                            queryParams.origins = `*${queryValue}*`;
                            let queryString = new URLSearchParams(queryParams).toString();
                            let result = await getFormOptions(`/groupby/origins?${queryString}`);
                            return result.data.options;
                        },
                        queryParamsFields: [{ fieldName: "groupName", queryIf: (val) => val !== "" }],
                        defaultVal: "",
                        selectAllowCreate: true,
                        vShowFieldVal: () => 1,
                    },
                    style: "width: 300px",
                },
                {
                    prop: "weight",
                    label: this.$i18n.t("originPolicy.weight"),
                    component: "FormInputNumber",
                    formItem: {
                        inputMaxNum: 100,
                        inputMinNum: 1,
                        vShowFieldVal: () => 1,
                    },
                    style: "width: 100px",
                },
                {
                    prop: "isHostEnabled",
                    label: this.$i18n.t("originPolicy.isHostEnabled"),
                    component: "FormCheckbox",
                    formItem: { vShowFieldVal: () => 1 },
                    style: "width: 100px",
                },
                {
                    prop: "isBackupHost",
                    label: this.$i18n.t("originPolicy.isBackupHost"),
                    component: "FormCheckbox",
                    formItem: { vShowFieldVal: () => 1 },
                    style: "width: 100px",
                },
                {
                    prop: "isCustomSettingEnabled",
                    label: this.$i18n.t("originPolicy.isCustomSettingEnabled"),
                    component: "FormCheckbox",
                    formItem: {
                        vShowFieldVal: () => (this.isShowCustomSetting ? 1 : 0),
                    },
                    style: "width: 100px",
                },
            ],
            customSettingFields: [
                {
                    prop: "hostHeaderType",
                    label: this.$t("originPolicy.customSetting.hostHeaderType"),
                    component: "FormSelect",
                    formItem: {
                        options: [
                            {
                                label: this.$i18n.t("originPolicy.customSetting.followFQDN"),
                                value: enumList.customSetting.hostHeaderType.FOLLOW_FQDN,
                            },
                            {
                                label: this.$i18n.t("originPolicy.customSetting.requestHost"),
                                value: enumList.customSetting.hostHeaderType.REQUEST_HOST,
                            },
                            {
                                label: this.$i18n.t("originPolicy.customSetting.custom"),
                                value: enumList.customSetting.hostHeaderType.CUSTOM,
                            },
                        ],
                        defaultVal: enumList.customSetting.hostHeaderType.FOLLOW_FQDN,
                        vShowFieldVal: () => 1,
                    },
                    style: "width: 300px",
                },
                {
                    prop: "hostHeader",
                    label: this.$t("originPolicy.customSetting.hostHeader"),
                    component: "FormInput",
                    formItem: {
                        vShowFieldVal: () => (this.isHostHeaderTypeCustom ? 1 : 0),
                    },
                    style: "width: 300px",
                },
                {
                    prop: "scheme",
                    label: this.$t("originPolicy.customSetting.scheme"),
                    component: "FormSelect",
                    formItem: {
                        options: [
                            {
                                label: "HTTP",
                                value: "http",
                            },
                            {
                                label: "HTTPS",
                                value: "https",
                            },
                            {
                                label: "Static",
                                value: "static",
                            },
                        ],
                        defaultVal: "http",
                        vShowFieldVal: () => 1,
                    },
                    style: "width: 300px",
                },
                {
                    prop: "portMappingType",
                    label: this.$t("originPolicy.customSetting.portMappingType"),
                    component: "FormSelect",
                    formItem: {
                        options: [
                            {
                                label: "Default",
                                value: "default",
                            },
                            {
                                label: "Static",
                                value: "static",
                            },
                        ],
                        defaultVal: enumList.customSetting.portMappingType.DEFAULT,
                        vShowFieldVal: () => 1,
                    },
                    style: "width: 300px",
                },
                {
                    prop: "port",
                    label: this.$t("originPolicy.customSetting.port"),
                    component: "FormInputNumber",
                    formItem: {
                        inputMaxNum: 65535,
                        inputMinNum: 1,
                        vShowFieldVal: () => (this.isPortMappingTypeDefault ? 1 : 0),
                    },
                    style: "width: 100px",
                },
            ],
        };
    },
    computed: {
        originModalTitle() {
            return this.isEditMode ? this.$t("originPolicy.editOrigin") : this.$t("originPolicy.addOrigin");
        },
        currentOriginFormData() {
            return this.isEditMode ? this.editOriginFormData : this.addOriginFormData;
        },
        isHostHeaderTypeCustom() {
            return (
                this.currentOriginFormData.customSetting.hostHeaderType === enumList.customSetting.hostHeaderType.CUSTOM
            );
        },
        isShowCustomSetting() {
            const enabledGroups =
                this.$store.state.platformPlan.multiTenancyConfigs.isOriginPolicyCustomSettingEnabled || [];
            return enabledGroups.includes(this.formData.groupName);
        },
        isCustomSettingCardVisible() {
            return this.isShowCustomSetting && this.currentOriginFormData.isCustomSettingEnabled;
        },
        isPortMappingTypeDefault() {
            return (
                this.currentOriginFormData.customSetting.portMappingType ===
                enumList.customSetting.portMappingType.DEFAULT
            );
        },
    },
    methods: {
        getEmptyFormData() {
            return {
                host: "",
                weight: 1,
                isHostEnabled: true,
                isBackupHost: false,
                isCustomSettingEnabled: false,
                customSetting: {
                    hostHeaderType: enumList.customSetting.hostHeaderType.FOLLOW_FQDN,
                    hostHeader: "",
                    scheme: "http",
                    portMappingType: "default",
                    port: 80,
                },
            };
        },
        async validateHost(host) {
            const checkHostResult = await ipValidate("origin", [host]);

            if (!checkHostResult.data.success) {
                this.$Message.warning(checkHostResult.data.message);
                return false;
            }

            return true;
        },
        async validateCustomHostHeader(formData) {
            if (!this.isHostHeaderTypeCustom) return true;
            if (["", null, undefined].includes(formData.customSetting.hostHeader)) {
                this.$Message.warning("Missing hostHeader");
                return false;
            }
            const checkIpResult = await ipValidate("origin", [formData.customSetting.hostHeader]);
            if (!checkIpResult.data.success) {
                this.$Message.warning(
                    `${this.$i18n.t("originPolicy.customSetting.hostHeader")} ${this.$i18n.t(
                        "rcmtable.validateUnsupportedText"
                    )}`
                );
                return false;
            }
            return true;
        },
        async confirmAddOrigin() {
            if (this.value.map((e) => e.host).includes(this.addOriginFormData.host))
                return this.$Message.warning("Host exist");
            if (["", null].includes(this.addOriginFormData.host)) return this.$Message.warning("Missing origin");

            const checkHostResult = await this.validateHost(this.addOriginFormData.host);
            if (!checkHostResult) return;

            if (["", null].includes(this.addOriginFormData.weight)) return this.$Message.warning("Missing weight");
            const valid = await this.validateCustomHostHeader(this.addOriginFormData);
            if (!valid) return;
            this.addOrigin();
        },
        addOrigin() {
            this.value.push(Object.assign(this.addOriginFormData, {}));
            this.cancelAddOrigin();
        },
        cancelAddOrigin() {
            this.isOriginModalShow = false;
            this.addOriginFormData = this.getEmptyFormData();
            this.$emit("modalSubmitComplete");
        },
        async confirmEditOrigin() {
            const checkHostResult = await this.validateHost(this.editOriginFormData.host);
            if (!checkHostResult) return;

            const valid = await this.validateCustomHostHeader(this.editOriginFormData);
            if (!valid) return;
            this.isEditMode = false;
            this.isOriginModalShow = false;
            this.editOriginFormData = this.getEmptyFormData();
            this.$emit("modalSubmitComplete");
        },
        cancelEditOrigin() {
            this.$refs.editForm.resetFields();
            this.isEditMode = false;
            this.isOriginModalShow = false;
        },
        removeOrigin(index) {
            this.value.splice(index, 1);
        },
        editOrigin(originData) {
            const formDataKeys = Object.keys(this.editOriginFormData);
            const initialFormData = this.editOriginFormData;
            this.editOriginFormData = Object.assign(originData, {});
            // 避免資料欄位更新後，舊資料無欄位處理
            formDataKeys.forEach((key) => {
                if (!this.editOriginFormData[key]) {
                    this.$set(this.editOriginFormData, key, initialFormData[key]);
                }
            });
            this.isEditMode = true;
            this.isOriginModalShow = true;
        },
        getBaseFieldsDescription(origin) {
            const { weight, isHostEnabled, isBackupHost } = origin;
            return `Weight: ${weight}, Enabled: ${isHostEnabled}, As Backup: ${isBackupHost}`;
        },
        getCustomSettingFieldsDescription(origin) {
            const { customSetting = {} } = origin;
            if (!this.isShowCustomSetting) return "";
            const { hostHeaderType, hostHeader, scheme, portMappingType, port } = customSetting;
            const customSettingFields = [
                `Host Header Type: ${hostHeaderType}`,
                hostHeaderType === enumList.customSetting.hostHeaderType.CUSTOM && `Host: ${hostHeader}`,
                `Scheme: ${scheme}`,
                `Port Mapping Type: ${portMappingType}`,
                portMappingType === enumList.customSetting.portMappingType.DEFAULT && `Port: ${port}`,
            ].filter(Boolean);
            return `${customSettingFields.join(", ")}`;
        },
    },
    mounted() {},
    created() {},
    destroyed() {},
    beforeDestroy() {},
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/AdvanceOriginsForm.vue